import { Component, inject, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";
import { CoreService } from "../../../../../../shared/src/lib/services/core.service";
import { ApiService } from "../../../../../../shared/src";
import { SnackbarService } from "../../../../../../shared/src/lib/services/snackbar.service";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { Subscription } from "rxjs";
import { ExRateService } from "../../../../../../shared/src/lib/services/ex-rate.service";

@Component({
    selector: "app-withdraw",
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        TranslateModule,
    ],
    templateUrl: "./withdraw.component.html",
    styleUrl: "./withdraw.component.scss"
})
export class WithdrawComponent implements OnDestroy {
  exRateSubscription: Subscription = new Subscription();
  coreService = inject(CoreService);
  exRateService = inject(ExRateService);
  apiService = inject(ApiService);
  snackbar = inject(SnackbarService);
  form: FormGroup;
  loader = inject(LoaderService);

  constructor(
    private fb: FormBuilder,
    public bottomSheetRef: MatBottomSheetRef,
  ) {
    this.form = this.fb.group({
      AMOUNT: ["", [Validators.required]],
      DESCRIPTION: [""],
      PASSWORD: ["", [Validators.required]],
    });
  }

  handleSubmit() {
    if (this.form.valid) {
      const authToken = this.apiService.getUserToken();
      const userId = authToken?.user?.ID;

      if (!userId) {
        console.error("No username found, cannot submit the bet.");
        return;
      }

      const data = {
        USER_ID: userId,
        ...this.form.value,
      };

      this.coreService.withdrawFunds(data).subscribe({
        next: (response: any) => {
          console.log(response);
          if (response?.status === "ok") {
            this.snackbar.openSnackbar({
              message: "Funds withdrawn successfully!",
            });
            this.form.reset();
            this.bottomSheetRef.dismiss();
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    } else {
      console.warn("Form is not valid:", this.form.errors);
    }
  }

  ngOnDestroy(): void {
    this.exRateSubscription.unsubscribe();
  }
}
